import styled from 'styled-components';
import snu from 'images/snu.svg';
import neodex_logo from 'images/neodex/neodex_logo.png';
import neodex from 'images/neodex/neodex.jpg';

const TopBar = styled.div`
  position: fixed;
  width: 100%;
  height: 50px;
  // background: #f1f2f1;
  // background: pink;
  background: LavenderBlush;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: 10px;  
`;

const Dummy = styled.div`
  height: 50px;
  // background: red;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  // background: red;

  &:hover {
    background: #eaeaea;
    background: lightgray;
    cursor: pointer;
  }
`;

const Icon = styled.div`
  // width: 40px;
  // height: 40px;
  width: 55px;
  margin-left: 10px;
  // cursor: pointer;
`;

const Title = styled.label`
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 500;
`;

const Notice = styled.label`
  // background: #eaeaea;
  // background: LavenderBlush;
  background: #fef5f8;
  font-size: 12px;
  display: flex;
  justify-content: center;
`;

const Image = styled.div`
  width: 100%;
`;

const NeoDex = () => {
  const handleGoHomepage = () => {
    window.open('http://www.neodex.co.kr');
  };

  return (
    <div className="NeoDex">
      <TopBar>
        <Container onClick={handleGoHomepage}>
          <Icon>
            <img src={neodex_logo} alt="neodex-logo" width="100%" />
          </Icon>
          <Title>주식회사 네오넥스</Title>
        </Container>
      </TopBar>
      <Dummy />
      <Notice>
        안되면 팝업차단 해지 또는 http://www.neodex.co.kr 로 직접 들어가세요.
      </Notice>          
      <Image><img src={neodex} alt="neodex" width="100%" /></Image>
    </div>
  );
};

export default NeoDex;